import { addTranslations } from '@fs/zion-locale'
import Footer from './Footer'

import translations from './locales'

addTranslations(translations)

export default Footer
